module.exports = __webpack_public_path__ + "static/img/02.a02ef75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/travelpolicy/02.jpg
// module id = kjzc
// module chunks = 0